import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import RedefinirSenha from './pages/RedefinirSenha';
import Dashboard from './pages/Dashboard';
import MembrosEquipe from './pages/MembrosEquipe';
import Celulas from './pages/Celulas';
import Clientes from './pages/Clientes';
import Projetos from './pages/Projetos';
import Agenda from './pages/Agenda';
import Perfil from './pages/Perfil';
import Relatorios from './pages/Relatorios';
import MembroEquipeDetalhe from './pages/MembroEquipeDetalhe';
import Financeiro from './pages/Financeiro';
import Comercial from './pages/Comercial';
import Marketing from './pages/Marketing';
import RH from './pages/RH';
import ProjetoDetalhe from './pages/ProjetoDetalhe';
import Roadmap from './pages/Roadmap';
import ControleCarga from './pages/ControleCarga';
import Layout from './components/Layout';
import ModuloBloqueado from './components/ModuloBloqueado';
import { CircularProgress, Box } from '@mui/material';
import CRM from './pages/CRM';
import LoginComo from './pages/LoginComo';

function RotaProtegida({ children, nome, apenasAdmin = false }) {
  const { user, loading, isSuperAdmin, isGestor } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) return <Navigate to="/login" />;

  if (apenasAdmin && !isSuperAdmin && !isGestor) {
    return (
      <Layout>
        <ModuloBloqueado nome={nome} semAutorizacao={true} />
      </Layout>
    );
  }

  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/redefinir-senha" element={<RedefinirSenha />} />
          <Route path="/" element={<RotaProtegida chave="dashboard" nome="Dashboard"><Dashboard /></RotaProtegida>} />
          <Route path="/membros-equipe" element={<RotaProtegida chave="membros_equipe" nome="Membros da Equipe"><MembrosEquipe /></RotaProtegida>} />
          <Route path="/celulas" element={<RotaProtegida chave="celulas" nome="Células"><Celulas /></RotaProtegida>} />
          <Route path="/membros-equipe/:id" element={<RotaProtegida chave="membros_equipe" nome="Membros da Equipe"><MembroEquipeDetalhe /></RotaProtegida>} />
          <Route path="/clientes" element={<RotaProtegida chave="clientes" nome="Clientes"><Clientes /></RotaProtegida>} />
          <Route path="/projetos" element={<RotaProtegida chave="projetos" nome="Projetos"><Projetos /></RotaProtegida>} />
          <Route path="/projetos/:id" element={<RotaProtegida chave="projetos" nome="Projetos"><ProjetoDetalhe /></RotaProtegida>} />
          <Route path="/agenda" element={<RotaProtegida chave="agenda" nome="Agenda"><Agenda /></RotaProtegida>} />
          <Route path="/financeiro" element={<RotaProtegida chave="financeiro" nome="Financeiro"><Financeiro /></RotaProtegida>} />
          <Route path="/comercial" element={<RotaProtegida chave="comercial" nome="Comercial"><Comercial /></RotaProtegida>} />
          <Route path="/crm" element={<RotaProtegida chave="crm" nome="CRM"><CRM /></RotaProtegida>} />
          <Route path="/marketing" element={<RotaProtegida chave="marketing" nome="Marketing"><Marketing /></RotaProtegida>} />
          <Route path="/rh" element={<RotaProtegida chave="rh" nome="RH"><RH /></RotaProtegida>} />
          <Route path="/relatorios" element={<RotaProtegida chave="relatorios" nome="Relatórios"><Relatorios /></RotaProtegida>} />
          <Route path="/roadmap" element={<RotaProtegida chave="roadmap" nome="Roadmap"><Roadmap /></RotaProtegida>} />
          <Route path="/controle-carga" element={<RotaProtegida chave="controle_carga" nome="Controle de Carga"><ControleCarga /></RotaProtegida>} />
          <Route path="/login-como" element={<RotaProtegida chave="dashboard" nome="Login como"><LoginComo /></RotaProtegida>} />
          <Route path="/perfil" element={<RotaProtegida chave="perfil" nome="Meu Perfil"><Perfil /></RotaProtegida>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;